export default __webpack_public_path__ + "static/media/add-unit-permit.86c56034.svg";